//import modules
import main from './app/main-start'
import adminPanel from './app/admin-panel'
import courseFront from './app/course-front'
import reports from './app/reports'


export default angular.module('app.parvulo', [
  main,
  adminPanel,
  courseFront,
  reports
  ])
  .name;



// WEBPACK FOOTER //
// ./src/projects.js